// Third-party
import React from 'react';
import { Options as ChartOptions } from 'highcharts';

// Components
import { HoldingIcon } from '../../common';
import GenericLegend from '../GenericLegend';

// Utils
import { formatCurrency } from '../../../../utils/i18n';
import { currencyToText } from '../../../../utils/currency';

type Props = {
  chartOptions: ChartOptions;
  sort?: boolean;
  showBaseCurrencies?: boolean;
};

const getData = (chartOptions: ChartOptions, sort: boolean) => {
  if (!chartOptions.series || chartOptions.series.length === 0) {
    return [];
  }

  const data = Object.values(chartOptions.series).map(serie => ({
    type: serie.itemType,
    color: serie.color,
    value: serie.data.length ? serie.data[serie.data.length - 1][1] : undefined,
    name: serie.name,
    currency: serie.currency,
    hideFromLegend: serie.hideFromLegend,
  }));

  return sort ? data.sort((d1, d2) => d2.value - d1.value) : data;
};

const GrowthLegend = ({ chartOptions, sort = true, showBaseCurrencies = false }: Props) => {
  const data = getData(chartOptions, sort);

  if (!data.length) {
    return null;
  }

  const legendItems = data
    .filter(datum => !datum.hideFromLegend)
    .map(datum => ({
      getLabel: () => (
        <div className="item-label">
          <HoldingIcon type={datum.type} color={datum.color} />
          <span className="legend-item-name" data-private data-dd-privacy="mask">
            {datum.name}
          </span>
          <span>&nbsp;:</span>
        </div>
      ),
      getValue: () => (
        <>
          <span className="legend-return">{formatCurrency(datum.value, 2)}</span>

          {datum.currency && !!showBaseCurrencies && (
            <div className="currency-label">
              <span>{currencyToText(datum.currency)}</span>
            </div>
          )}
        </>
      ),
    }));

  return <GenericLegend items={legendItems} />;
};

export default GrowthLegend;
